module.exports = __webpack_public_path__ + "static/media/battles-info-box-icon.15d16eaf.png";